import React from 'react';
import { Route, Switch } from 'react-router-dom';
import './App.scss';
import PrivatePage from './core/component/private-page';
import { PRIVATE_MODULES } from './shared/data-models/private-module';

function App() {
    const Login = React.lazy(() => import('./core/component/login'));
    const Logout = React.lazy(() => import('./core/component/logout'));
    const Home = React.lazy(() => import('./core/component/home'));
    const ErrorPage = React.lazy(() => import('./shared/components/error-page'));

    return (
        <Switch>
            <Route path='/login'>
                <Login />
            </Route>
            <Route path='/logout'>
                <Logout />
            </Route>
            <Route path={PRIVATE_MODULES.map((module: string): string => `/${module}`)}>
                <PrivatePage />
            </Route>
            <Route exact path='/'>
                <Home />
            </Route>
            <Route path='*'>
                <ErrorPage code={404} />
            </Route>
        </Switch>
    );
}

export default App;
